<template>
    <div class="newCase">
      <!--新建案例页面父容器-->
      <rtas-par v-show="this.activeNum === 3"></rtas-par>
      <rtas-road v-show="this.activeNum === 2"></rtas-road>
      <rtas-env v-show="this.activeNum === 1"></rtas-env>
      <rtas-total v-show="this.activeNum === 0"></rtas-total>
      <rtas-step></rtas-step>
    </div>
</template>

<script>
  import rtasStep from './newCase_steps'
  import rtasTotal from './newCase_total'
  import rtasEnv from './newCase_env'
  import rtasRoad from './newCase_road'
  import rtasPar from './newCase_par'
  import bus from  './bus'

    export default {
      name: "新建案例数据",
      components:{
        rtasStep,
        rtasTotal,
        rtasEnv,
        rtasRoad,
        rtasPar
      },
      data() {
        return {
          activeNum:0
        }
      },
      created(){
        // 总体信息单击下一步
        bus.$on('activeTotal', msg => {
          this.activeNum = msg;
        });
        // 环境信息单击下一步
        bus.$on('envNext', msg => {
          this.activeNum = msg;
        });
        // 环境信息单击上一步
        bus.$on('envLast', msg => {
          this.activeNum = msg;
        });
        // 道路信息单击下一步
        bus.$on('roadNext', msg => {
          this.activeNum = msg;
        });
        // 道路信息单击上一步
        bus.$on('roadLast', msg => {
          this.activeNum = msg;
        });
        // 参与方信息单击上一步
        bus.$on('parLast', msg => {
          this.activeNum = msg;
        });
      }
    }
</script>

<style scoped>
.newCase{
  width: 100%;
  height: calc(100% - 34px);
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/data/newCase.vue